export const Languages = {
  English: 'en',
  Spanish: 'es'
}

const languageIdentifier = 'lang'

export const currentLanguage = localStorage.getItem(languageIdentifier)

export const isLanguageSpanish = currentLanguage === Languages.Spanish

export const invertedLanguage =
  Languages[isLanguageSpanish ? 'English' : 'Spanish']

export const setLanguage = (lang: string): void =>
  localStorage.setItem(languageIdentifier, lang)
